import { Action } from '../types'
import { Button } from '@mui/material'
import React from 'react'

export function Delete({
  action,
  onActionChange,
}: {
  action?: Action
  onActionChange: (action?: Action, done?: boolean) => void
}) {
  if (action?.actionType === 'delete') return null
  return (
    <Button onClick={() => onActionChange({ actionType: 'delete' }, true)}>
      Add Delete Action
    </Button>
  )
}
